function formatDateToHour(hour: string | undefined | null): string {
    return hour?.split('T')[1].split('.')[0] || '';
}

export default formatDateToHour;
